function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "321-play-logo-white");

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M66.181,109.233a16.193,16.193,0,0,1-11.527-4.776,6,6,0,1,1,8.486-8.484,4.3,4.3,0,1,0,3.041-7.342,6,6,0,0,1,0-12,16.3,16.3,0,0,1,0,32.6Z",
  fill: "#fff"
}), React.createElement("path", {
  d: "M66.181,88.613a6,6,0,1,1,0-12,4.3,4.3,0,1,0-3.041-7.342,6,6,0,1,1-8.486-8.485A16.3,16.3,0,1,1,66.181,88.613Z",
  fill: "#fff"
})), React.createElement("g", null, React.createElement("path", {
  d: "M110.74,85.6A6,6,0,0,1,106.5,75.354a4.3,4.3,0,1,0-6.082-6.083,6,6,0,0,1-8.485-8.485,16.3,16.3,0,1,1,23.052,23.052A5.979,5.979,0,0,1,110.74,85.6Z",
  fill: "#fff"
}), React.createElement("path", {
  d: "M103.016,93.32a6,6,0,0,1-4.243-10.243l7.724-7.723a6,6,0,0,1,8.485,8.484l-7.723,7.724A5.981,5.981,0,0,1,103.016,93.32Z",
  fill: "#fff"
}), React.createElement("path", {
  d: "M113.757,109.233h-20.6a6,6,0,0,1,0-12h20.6a6,6,0,0,1,0,12Z",
  fill: "#fff"
})), React.createElement("g", null, React.createElement("path", {
  d: "M138,109.233a6,6,0,0,1-6-6V62.011a6,6,0,1,1,12,0v41.222A6,6,0,0,1,138,109.233Z",
  fill: "#fff"
}), React.createElement("path", {
  d: "M129.985,76.029a6,6,0,0,1-4.242-10.243l8.016-8.017a6,6,0,1,1,8.486,8.484l-8.017,8.018A5.979,5.979,0,0,1,129.985,76.029Z",
  fill: "#fff"
})), React.createElement("path", {
  d: "M251.329,111.1a6,6,0,0,1-6-6V62.173a6,6,0,0,1,12,0V105.1A6,6,0,0,1,251.329,111.1Z",
  fill: "#fff"
}), React.createElement("g", null, React.createElement("path", {
  d: "M377.743,66.873a6,6,0,0,1-6-6V58.9a6,6,0,1,1,12,0v1.976A6,6,0,0,1,377.743,66.873Zm-40.9,0a6,6,0,0,1-6-6V58.9a6,6,0,1,1,12,0v1.976A6,6,0,0,1,336.846,66.873Z",
  fill: "#fff"
}), React.createElement("path", {
  d: "M357.3,105.777a26.45,26.45,0,0,1-26.449-26.449,6,6,0,1,1,12,0,14.449,14.449,0,1,0,28.9,0,6,6,0,0,1,12,0A26.45,26.45,0,0,1,357.3,105.777Z",
  fill: "#fff"
}), React.createElement("path", {
  d: "M357.3,111.1a6,6,0,0,1-6-6V99.777a6,6,0,1,1,12,0V105.1A6,6,0,0,1,357.3,111.1Z",
  fill: "#fff"
})), React.createElement("g", null, React.createElement("path", {
  d: "M291.63,111.1A26.449,26.449,0,1,1,318.078,84.65,26.478,26.478,0,0,1,291.63,111.1Zm0-40.9A14.449,14.449,0,1,0,306.078,84.65,14.465,14.465,0,0,0,291.63,70.2Z",
  fill: "#fff"
}), React.createElement("path", {
  d: "M314.105,111.1a6,6,0,0,1-6-6V62.173a6,6,0,0,1,12,0V105.1A6,6,0,0,1,314.105,111.1Z",
  fill: "#fff"
})), React.createElement("g", null, React.createElement("path", {
  d: "M211.029,109.058a26.437,26.437,0,1,1,18.7-7.735A26.351,26.351,0,0,1,211.029,109.058Zm0-40.878a14.4,14.4,0,0,0-10.216,4.225h0a14.465,14.465,0,1,0,10.216-4.226Zm-14.459-.018h0Z",
  fill: "#fff"
}), React.createElement("path", {
  d: "M188.553,111.1a6,6,0,0,1-6-6V62.173a6,6,0,0,1,12,0V105.1A6,6,0,0,1,188.553,111.1Z",
  fill: "#fff"
})), React.createElement("path", {
  d: "M164.826,88.6h-5.321a6,6,0,0,1,0-12h5.321a6,6,0,0,1,0,12Z",
  fill: "#fff"
}));

var SvgLogoWhite = function SvgLogoWhite(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "154.037mm",
    height: "57.854mm",
    viewBox: "0 0 436.64 163.995",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLogoWhite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo-white.0acae9e6.svg";
export { ForwardRef as ReactComponent };